import * as React from 'react';
import { useMessageHandler } from '~/Features/Messaging/useMessageHandler';
import { SummaryFocus } from './Events/SummaryFocus';

export function useSummaryFocusManagerEvents<T extends HTMLElement | null>() {
    const anchorRef = React.useRef<T>(null);

    useMessageHandler(SummaryFocus.id, () => {
        anchorRef.current && anchorRef.current.focus();
    });

    return anchorRef;
}
